import { gql } from '@apollo/client';

export * from './suggestedChangesNotifications.query.generated';

export const SUGGESTED_CHANGES_NOTIFICATIONS = gql`
  query suggestedChangesNotifications($escrowId: ID!) {
    depositorSuggestedChanges: suggestedChanges(
      escrowId: $escrowId
      status: pending
      changeType: DepositorSuggestedChange
    ) {
      nodesCount
      nodes {
        id
        partyStatus
        creatorType
        receiverType
      }
    }
    beneficiarySuggestedChanges: suggestedChanges(
      escrowId: $escrowId
      status: pending
      changeType: BeneficiarySuggestedChange
    ) {
      nodesCount
      nodes {
        id
        partyStatus
        creatorType
        receiverType
      }
    }
    notificationSuggestedChanges: suggestedChanges(
      escrowId: $escrowId
      status: pending
      changeType: NotificationSuggestedChange
    ) {
      nodesCount
      nodes {
        id
        partyStatus
        creatorType
        receiverType
      }
    }
    depositSuggestedChanges: suggestedChanges(
      escrowId: $escrowId
      status: pending
      changeType: DepositSuggestedChange
    ) {
      nodesCount
      nodes {
        id
        partyStatus
        creatorType
        receiverType
      }
    }
    agreementSuggestedChanges: suggestedChanges(
      escrowId: $escrowId
      status: pending
      changeType: AgreementSuggestedChange
    ) {
      nodesCount
      nodes {
        id
        partyStatus
        creatorType
        receiverType
      }
    }
    environmentSuggestedChanges: suggestedChanges(
      escrowId: $escrowId
      status: pending
      changeType: EnvironmentSuggestedChange
    ) {
      nodesCount
      nodes {
        id
        partyStatus
        creatorType
        receiverType
      }
    }
  }
`;
